import { useVisitDialog } from "./DialogContext";
import { VisitModalLayout } from "./VisitModalLayout";
import Remarks from "../../../../components/remark/Remarks";
import { VISIT_REMARK } from "../../../../api/allApi_List";

VisitModalLayout.VisitRemark = function VisitRemark() {
  const { visit, setVisitViewDetails, successView } = useVisitDialog();
  if (successView) return null;
  return (
    <Remarks
      remarkList={visit.remarks}
      dataId={visit.id}
      apiUrl={VISIT_REMARK}
      setViewDetails={setVisitViewDetails}
    />
  );
};
